import { render, staticRenderFns } from "./BatchRow.vue?vue&type=template&id=689cc987"
import script from "./BatchRow.vue?vue&type=script&lang=js"
export * from "./BatchRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports